import { useApiQuery } from "./use-api-query.ts";

export interface ModelEntry {
  id: string;
  name: string;
}

export interface ModelDefaults {
  default: string;
  lightweight: string;
  max: string;
  ultra: string;
}

export interface ModelsResponse {
  defaults: ModelDefaults;
  models: ModelEntry[];
}

export function useModels(search?: string) {
  const path = search ? `/models?search=${encodeURIComponent(search)}` : "/models";
  return useApiQuery<ModelsResponse>(path, {
    refetchInterval: 5 * 60 * 1000, // 5 min — matches backend cache TTL
    refetchOnWindowFocus: false,
  });
}
